import React, { useState, useEffect } from 'react'
import file_icon from './img/bx-file-blank.svg'
import download_icon from './img/bx-download.svg'
import dayjs from 'dayjs'
import { ButtonActionDrop } from '../Buttons/ButtonActionDrop/ButtonActionDrop'
import './FileItemComponent.scss'

const FileItemComponent = ({
    eventId,
    created_at,
    file_size_kb,
    new_filename,
    url,
    authorEmail,
    positionDrop,
    fetchDeleteFiles,
    fetchGetFiles,
    type,
    comment_id,
    saveFile,
    setSaveFile,
    ind,
    isDelete = true,
    setCurrentFile,
    files = false,
    setIsModalEditFile,
    file_id,
    message_id,
    isAuthor,
    messageData,
    early_message_id,
    currentPermission = null,
    disabled = false
}) => {

    const email = localStorage.getItem('email')
    const btns_files = files ? [
        {
            btn: 'Копировать ссылку',
            func: (e) => {
                navigator.clipboard.writeText(url)
            },
        },

    ] : []



    const isDeleteLocal = saveFile?.some((el) => el.url === url)

    const btns_author = [
        ...btns_files,
        ...disabled ? [] : [
            {
                btn: 'Переименовать файл',
                func: (e) => {
                    setCurrentFile({
                        id: comment_id, "Название": [
                            new_filename, url
                        ]
                    })
                    setIsModalEditFile(true)
                },
            },
            {
                btn: 'Удалить',
                func: () => {
                    if (type === 'comments') {
                        if (!saveFile || saveFile?.length < 1) {
                            fetchDeleteFiles(eventId || message_id, url, messageData, early_message_id)
                            setTimeout(() => { fetchGetFiles(type) }, 500)
                        } else {
                            if (!isDeleteLocal) {
                                fetchDeleteFiles(eventId || message_id, url, messageData, early_message_id)
                                setTimeout(() => { fetchGetFiles(type) }, 500)
                            } else {
                                setSaveFile((prev) => {
                                    const curr_files_arr = prev.filter((el, indx) => indx !== ind)
                                    return curr_files_arr
                                })
                            }
                        }
                    } else {
                        fetchDeleteFiles(eventId || message_id, url, messageData || 'description', early_message_id || file_id)
                        setTimeout(() => { fetchGetFiles(type) }, 500)
                    }
                },

            }],
    ];

    const handleDownload = async (e) => {
        e.stopPropagation();
        const response = await fetch(url);
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = new_filename; // Желаемое имя
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    };

    return (
        <div className='file-item-component' key={created_at + url}
            onClick={(e) => {
                if (setCurrentFile) {
                    setCurrentFile({ id: comment_id })
                }
            }}
        >
            <p className='file-item-component__link-file'>
                <img className='file-item-component__link-file-img' src={file_icon} />
                <span>{new_filename}</span>
            </p>

            <div className='file-item-component__hide-box'>
                <a className='file-item-component__link-btn'
                    target='_blank'
                    href={url}
                    download={new_filename}
                    onClick={handleDownload}
                >
                    <img className='file-item-component__link-file-img' src={download_icon} /> Скачать файл
                </a>

                {((email == authorEmail) || isAuthor) && <ButtonActionDrop
                    id={url}
                    btns={btns_author}
                    color={'#F3F4F6'}
                    size={'m'}
                    positionDrop={positionDrop}
                />}
            </div>

            <div className='file-item-component__link-info'>
                <span>{Math.ceil((file_size_kb / (1024 * 1024)) * 100) / 100} МБ</span>
                <span>{dayjs(created_at).format('DD.MM.YY HH:mm')}</span>
            </div>
        </div>
    )
}

export { FileItemComponent }